import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

@NgModule({
  imports: [SharedModule],
  exports: [SharedModule]
})
export class NovoCanalVendaMultiSelectModule {}
